@if (skjema().length > 0) {

  <div class="antall-valgt" [ngClass]="{'antall-valgt__ingen':antallValgt() == 0}">
    <span>
      {{ antallValgt() }}/{{ skjema().length }} {{ "valgt"|translate }}
    </span>
  </div>

  <table>
    <tr>
      <th class="valgt">
        <mat-checkbox (click)="endreAlle()" [indeterminate]="!alleValgt() && !ingenValgt()" [checked]="alleValgt()" matTooltip="{{'Velg alle eller ingen medlemmer'|translate}}"/>
      </th>
      <th class="valgt-tittelrad" colspan="2" (click)="endreAlle()" matTooltip="{{'Velg alle eller ingen medlemmer'|translate}}">{{ "Medlem"|translate }}</th>
      @if (skalSignereValgSynlig()) {
        <th colspan="2" class="skal-signere">{{ "Skal signere protokollen"|translate }}</th>
      } @else {
        <th>{{ "Rolle"|translate }}</th>
      }
    </tr>
    @for (rad of skjema().controls; track rad.value.medlem!.id; ) {
      <moete-rediger-deltaker [skjema]="rad" [skalSignereValgSynlig]="skalSignereValgSynlig()"/>
    }
  </table>

} @else {

  <tips>
    <span>{{ "Gruppen inneholder ingen medlemmer"|translate }} <!--@todo lage en bedre melding-->.</span>
  </tips>
}
